import { render, staticRenderFns } from "./DialogDefault.vue?vue&type=template&id=af65639a"
import script from "./DialogDefault.vue?vue&type=script&lang=js"
export * from "./DialogDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports